import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectEcommBanner = (state: RootState) => state.banner;

const selectEcommBanners = createSelector(
  selectEcommBanner,
  (state) => state.banners
);

const selectEcommFilter = createSelector(
  selectEcommBanner,
  (state) => state.bannerFilter
);

export const selectors = {
  selectEcommBanners,
  selectEcommFilter
};
